import { EventCalenderViewModel } from './event.calender.view.model';

export class PagedEventCalenderViewDetails {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: EventCalenderViewModel[] = [];
}
